import { styled } from '@acko-tech/building-blocks.ui.common'

export const Card = styled.div`
    background: #faf3e6;
    border-radius: 20px;
    padding: 20px 18px;
`

export const Header = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 14px;
`

export const WarningBadge = styled.div`
    flex-shrink: 0;
    width: 38px;
    height: 38px;
`

export const Copy = styled.p`
    margin: 0;
    font-family: Euclid Circular B;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: #ed8b1f;
`

export const Highlights = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 16px;
    padding-left: 48px;
`

export const Highlight = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    color: #ed8b1f;
    font-family: Euclid Circular B;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
`

export const HighlightIcon = styled.div`
    width: 22px;
    height: 22px;
    color: #4b4665;
    flex-shrink: 0;
`
